<template>
  <!--  administrator-->
  <div class="organization">
    <div style="text-align: right">
      <el-button type="primary" round style="margin-right: 16px" @click="
        admiDialog = true;
      admiTitle = 'Add an administrator';
      ">NEW</el-button>
    </div>
    <div class="tabel" v-loading="admiLoading">
      <el-table v-if="admiData.length != 0" :data="admiData" style="width: 100%; font-weight: normal">
        <el-table-column header-align="center" align="center" prop="username" label="Username"></el-table-column>
        <el-table-column prop="type_name" label="Role"></el-table-column>

        <el-table-column prop="organization_name" label="Organization permission"></el-table-column>

        <el-table-column prop="store_name" label="Store permission"></el-table-column>


        <el-table-column label="Actions" width="130px">
          <template slot-scope="scope">
            <div class="action">
              <span @click="handleEdit(scope.$index, scope.row)">
                <img src="../assets/image/edit@2x.png" alt="" />
              </span>
              <span @click="handleDelete(scope.$index, scope.row)">
                <img src="../assets/image/delete@2x.png" alt="" />
              </span>
              <span @click="handleResetPwd(scope.$index, scope.row)">
                <img src="../assets/image/reset@2x.png" alt="" />
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div v-else class="empty">
        <div>
          <img src="../assets/image/list_blank.png" alt="" />
          <h2 style="color: #cccccc; font-size: 16px">No items found</h2>
        </div>
      </div>
    </div>
    <div class="btomPagin">
      <div class="innerLeft">
        {{ currentPage }} - <span>{{ admiData.length }}</span> of
        <span>{{ pageTotal }}</span> items
      </div>
      <div>
        <el-pagination :page-size="10" layout="prev, pager, next, jumper" :current-page="currentPage" :total="pageTotal"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>

    <!-- edit / add  admin -->
    <el-dialog :close-on-click-modal="false" style="padding-top: 0" :title="admiTitle" :visible.sync="admiDialog"
      width="40%">
      <div class="addInner">
        <el-form :model="addAdmi" label-position="top" :rules="rules" status-icon ref="admiRuleForm"
          :show-message="false">
          <!--  Role -->
          <el-form-item label="Role" label-width="120px" prop="role">
            <el-select v-model="addAdmi.role" placeholder="Select a role">
              <el-option v-for="item in roleOptions" :key="item.type_id" :label="item.type_name" :value="item.type_id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- Username -->
          <el-form-item label="Username" label-width="120px" prop="username">
            <el-input v-model="addAdmi.username" placeholder="Username" autocomplete="off"></el-input>
          </el-form-item>
          <!-- Password -->
          <el-form-item label="Password" label-width="120px" prop="password" v-if="!tabelEditTag">
            <el-input v-model="addAdmi.password" placeholder="Password" autocomplete="off">
            </el-input>
          </el-form-item>
          <!-- Organization permission -->
          <el-form-item label="Organization permission" label-width="120px" prop="organization">
            <el-select v-model="addAdmi.organization" placeholder="Select one or more organization(s)" multiple>
              <el-option v-for="item in organOptions" :key="item.organization_id" :label="item.organization_name"
                :value="item.organization_id">
              </el-option>
            </el-select>
          </el-form-item>
          <!--  Store permission -->
          <el-form-item label="Store permission" label-width="120px" prop="store">
            <el-select v-model="addAdmi.store" placeholder="Select one or more store(s)" multiple>
              <el-option v-for="item in storeOptions" :key="item.store_id" :label="item.store_name"
                :value="item.store_id">
              </el-option>
            </el-select>
          </el-form-item>
          <!--  group permission -->
          <el-form-item label="Driver group permission" label-width="120px" prop="store">
            <el-select v-model="addAdmi.group_ids" placeholder="Select one or more store(s)" multiple>
              <el-option v-for="item in groupOptions" :key="item.id" :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="cancelAdmi" plain>Cancel</el-button>
        <el-button type="primary" @click="saveAddNewAdmi" round>Save</el-button>
      </span>
    </el-dialog>


    <!-- del dialog -->
    <el-dialog :close-on-click-modal="false" style="padding-top: 0" :title="deleteTitle" :visible.sync="deleteDialog"
      width="35%">
      <div class="addInner" style="margin-top: 24px">
        {{ delUserName }} will be permanently deleted. This account would not be used.
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="deleteDialog = false; delUserName = '';" plain>Cancel</el-button>
        <el-button type="primary" @click="confirmDelete" round>Delete</el-button>
      </span>
    </el-dialog>

    <!-- update pwd dialog -->
    <el-dialog :close-on-click-modal="false" style="padding-top: 0" :title="pwdTitle" :visible.sync="pwdDialog"
      width="40%">

      <div class="addInner">
        <el-form :model="updateAdmi" label-position="top" :rules="rules" status-icon ref="admiRuleForm"
          :show-message="false">
          <!-- Password -->
          <el-form-item label="New Password" label-width="120px" prop="password">
            <el-input v-model="updateAdmi.password" placeholder="New Password" autocomplete="off">
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="cancelUpdatePwd" plain>Cancel</el-button>
        <el-button type="primary" @click="saveUpdatePwd" round>Save</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
import { getAdministratorLlist, getTypeList, getOrganizationList, getStoreList, addAdministrator, editAdministrator, delAdministrator } from "@/api/administrator";
import {getGroupList} from "@/api/driver";
// getGroupList


export default {
  name: "administrator",
  components: {},
  data() {
    return {
      admiLoading: false,
      currentPage: 1,
      pageTotal: 0,
      admiDialog: false,
      admiTitle: 'Add an administrator',
      admiData: [],
      groupOptions:[],
      addAdmi: {
        role: '',
        username: '',
        password: '',
        organization: '',
        store: '',
        group_ids:"",
      },
      rules: {
        role: [
          { required: true, message: '', trigger: 'blur' },
        ],

        username: [
          { required: true, message: '', trigger: 'blur' },
        ],

        password: [
          { required: true, message: '', trigger: 'blur' },
        ],

        organization: [
          { required: true, message: '', trigger: 'blur' },
        ],

        store: [
          { required: true, message: '', trigger: 'blur' },
        ],

      },
      roleOptions: [],
      organOptions: [],
      storeOptions: [],
      tabelEditTag: false,
      administrator_id: '',
      deleteDialog: false,
      deleteTitle: '',
      delUserName: '',

      pwdDialog:false,
      pwdTitle:'',
      updateAdmi:{
        password:''
      },
      editInputOrgLength:0,//编辑时使用


    };
  },
  created() {
    this.getTableListData();
    this.getRolesListOptionData()
    this.getOrganOptionsListOptionData()
    this.getStoreOptionsListOptionData()
    this.getGroupOptionsListOptionData()
  },
  watch:{
    admiDialog(val){
      if(!val){
        this.cancelAdmi()
      }
    },

    'addAdmi.organization'(val){
      // console.log('--组织变化，，，',val)
      if (this.admiTitle == 'Add an administrator') {
          //this.addAdmi.store = ''
          this.getStoreOptionsListOptionData()
        }else{
          // console.log('编辑模式。。。',this.addAdmi.organization)
          if(this.editInputOrgLength == val.length){
            // console.log('11111111')
            this.editInputOrgLength = 0
            this.getStoreOptionsListOptionData()
          }else{
            // this.addAdmi.store = ''
            this.getStoreOptionsListOptionData()
          }
      }


    }

  },
  methods: {
    // groupOptions
    getGroupOptionsListOptionData(){
      getGroupList({
        page:1,
        limit:''
      }).then(res=>{
        if (res.code == 200){
          this.groupOptions = res.data.data
        }
      })
    },
    //获取表单数据
    getTableListData() {
      this.admiLoading = true;
      getAdministratorLlist({
        page: this.currentPage,
        limit: 10,
        order: "time desc",
      }).then((res) => {
        this.admiLoading = false;

        this.admiData = res.data.data;
        this.pageTotal = res.data.count;
        // console.log('--获取表单数据--', res, this.admiData, this.pageTotal)
      });
    },

    //新增/编辑获取 role 数据
    getRolesListOptionData() {
      getTypeList({
        page: 1,
      }).then((res) => {
        this.roleOptions = res.data;
        // console.log("--------gettypelist---", this.roleOptions, res.data);
        // this.roleOptions.unshift({
        //   type_id: 0,
        //   type_name: "No roles",
        // });
      });
    },
    //新增/编辑获取 organOptions 数据
    getOrganOptionsListOptionData() {
      getOrganizationList({
        page: 1,
      }).then((res) => {
        this.organOptions = res.data;
        // console.log("--------get organOptions---", this.organOptions, res.data);
        // this.organOptions.unshift({
        //   organization_id: 0,
        //   organization_name: "No organization",
        // });
      });
    },


    getArrEqual(arr1, arr2) {
        let newArr = [];
        for (let i = 0; i < arr2.length; i++) {
          for (let j = 0; j < arr1.length; j++) {
            if(arr1[j] === arr2[i]){
              newArr.push(arr1[j]);
            }
        }
      }
      return newArr;
    },

    //新增/编辑获取 storeOptions 数据
    getStoreOptionsListOptionData() {
      getStoreList({
        page: 1,
        organization_ids:this.addAdmi.organization
      }).then((res) => {
        this.storeOptions = res.data;
        // console.log("--------get storeOptions---", this.storeOptions,this.addAdmi.store);

        let resArr = []
        this.storeOptions.forEach(element => {
          resArr.push(element.store_id)
        });

        // console.log('--resArr--',resArr,this.addAdmi.store)

        let newArr = this.getArrEqual(resArr,this.addAdmi.store)

        // console.log('--相同的数据是--',newArr)

        this.addAdmi.store = [...newArr]
        if(this.addAdmi.organization.length == 0){
          this.addAdmi.store = ''
        }

        // this.storeOptions.unshift({
        //   store_id: 0,
        //   store_name: "No store",
        // });
      });
    },


    //保存按钮 新增/编辑
    saveAddNewAdmi() {
      this.formValidate()

      if (!this.formValidate()) {
        this.$message({
          type: 'warning',
          message: 'Some information missing'
        })
      } else {
        if (this.admiTitle == 'Add an administrator') {
          let postObj = {
            type: this.addAdmi.role,
            username: this.addAdmi.username,
            password: this.addAdmi.password,
            organization_ids: this.addAdmi.organization,
            store_ids: this.addAdmi.store,
            group_ids:this.addAdmi.group_ids
          }
          addAdministrator(postObj).then(res => {
            if (res.code == 200) {
              this.admiDialog = false
              this.currentPage = 1
              this.getTableListData()
              this.$message({
                message: res.data,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'error'
              });
            }
          })
        } else if (this.admiTitle == 'Edit an administrator') {
          let postObj = {
            type: this.addAdmi.role,
            username: this.addAdmi.username,
            organization_ids: this.addAdmi.organization,
            store_ids: this.addAdmi.store,
            group_ids:this.addAdmi.group_ids,
            administrator_id: this.administrator_id
          }
          editAdministrator(postObj).then(res => {
            if (res.code == 200) {
              this.admiDialog = false
              this.currentPage = 1
              this.getTableListData()
              this.$message({
                message: res.data,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'error'
              });
            }
          })
        }
      }
    },


    //表单校验
    formValidate() {
      let flag = false
      this.$refs['admiRuleForm'].validate((v) => {
        flag = v
      })
      return flag
    },

    cancelAdmi() {
      this.admiDialog = false
      this.tabelEditTag = false

      this.addAdmi.username = ''
      this.addAdmi.role = ''
      this.addAdmi.organization = ''
      this.addAdmi.store = ''
      this.addAdmi.password = ''
      this.administrator_id = ''

    },

    handleEdit(index, row) {
      this.admiTitle = 'Edit an administrator'
      this.addAdmi.username = row.username
      this.addAdmi.role = parseInt(row.type)
      this.addAdmi.organization = row.organization_ids.map(Number)
      this.addAdmi.store = row.store_ids.map(Number)
      this.addAdmi.group_ids = row.group_id.map(Number)
      this.administrator_id = row.administrator_id

      this.admiDialog = true
      this.tabelEditTag = true

      this.editInputOrgLength = this.addAdmi.organization.length
    },

    handleDelete(index, row) {
      this.deleteDialog = true
      if (row.username) {

        this.delUserName = row.username
        this.administrator_id = row.administrator_id

        this.deleteTitle = 'Delete the account'
      } else {

      }
    },

    //确认删除
    confirmDelete() {
      delAdministrator({
        administrator_id: this.administrator_id
      }).then(res => {
        this.deleteDialog = false
        if (res.code == 200) {
          this.currentPage = 1
          this.getTableListData()
          this.$message({
            type: 'success',
            message: res.data
          })
        }
      })

    },
    handleResetPwd(index,row){
      this.pwdTitle= 'Reset Password'
      this.administrator_id = row.administrator_id


      this.updateAdmi.username = row.username
      this.updateAdmi.role = parseInt(row.type)
      this.updateAdmi.organization = row.organization_ids.map(Number)
      this.updateAdmi.store = row.store_ids.map(Number)

      this.pwdDialog= true
    },

    cancelUpdatePwd(){
      this.pwdDialog = false

      this.updateAdmi = {}
      this.administrator_id = ''

    },

    saveUpdatePwd(){
      this.formValidate()
      if (!this.formValidate()) {
        this.$message({
          type: 'warning',
          message: 'Some information missing'
        })
      } else {
        if (this.pwdTitle == 'Reset Password') {
          let postObj = {
            password: this.updateAdmi.password,
            type: this.updateAdmi.role,
            username: this.updateAdmi.username,
            organization_ids: this.updateAdmi.organization,
            store_ids: this.updateAdmi.store,
            administrator_id: this.administrator_id
          }

          editAdministrator(postObj).then(res => {
            if (res.code == 200) {
              this.pwdDialog = false
              this.currentPage = 1
              this.getTableListData()
              this.$message({
                message: res.data,
                type: 'success'
              });
              this.cancelUpdatePwd()
            } else {
              this.$message({
                message: res.msg,
                type: 'error'
              });
            }
          })
        }
      }
    }

  },
};
</script>

<style scoped lang="less">
.organization {
  /deep/.changePadding {
    padding-left: 48px;
  }

  .tabel {
    margin-top: 16px;

    .action {
      span {
        cursor: pointer;
      }

      img {
        width: 16px;
        margin-right: 16px;
      }
    }
  }

  .empty {
    width: 200px;
    height: 387px;
    margin: 20px auto;
    text-align: center;
    position: relative;

    div {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    h2 {
      font-size: 16px;
    }

    img {
      width: 100%;
      height: 200px;
      margin: 0;
    }
  }

  .btomPagin {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    padding-left: 16px;

    .innerLeft {
      font-size: 16px;
      font-family: SFPro-Regular, SFPro;
      font-weight: 400;
      color: #1f2d42;
      line-height: 20px;
    }
  }

  .backBox {
    display: flex;
    font-weight: normal;

    .innerLeft {
      margin-right: 20px;
      cursor: pointer;
    }
  }

  .addInner {
    font-weight: normal;
    font-size: 14px;
    color: #1f2d42;
    line-height: 20px;
    word-wrap: break-word;

    .btomSuffix {
      /deep/.el-input__prefix {
        margin-left: 12px;
        color: #1f2d42;
      }

      ///deep/.el-input__inner{
      //  border-left: none;
      //}
      ///deep/.el-input-group__prepend{
      //  background: none;
      //  padding: 0 8px 0 12px;
      //}
    }
  }
}
</style>
